import React from "react";
import { useTranslation } from "react-i18next";

const LocationBanner = () => {
  const { t } = useTranslation();
  return (
    <a
      className="nineties-banner"
      href="https://maps.app.goo.gl/v464rw44xaLKpmoV6"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="banner-content">
        <span className="emoji">📍</span>
        <span className="text">{t("whereItHappens")}</span>
      </div>
    </a>
  );
};

export default LocationBanner;
